import { useToast } from "@/components/podkit/toasts/use-toast";
import { useListPreferences, useSetPreference } from "@/queries/user-preferences-queries";
import { formatError } from "@/utils/errors";
import { useCallback } from "react";

const DEFAULT_EDITOR = "DEFAULT_EDITOR";

export function useDefaultEditor() {
    const { preferences, isPending: isPendingPreferences } = useListPreferences();

    return {
        editorId: preferences?.find((p) => p.key === DEFAULT_EDITOR)?.value,
        isPending: isPendingPreferences,
    };
}

export function useSetDefaultEditor() {
    const { toast } = useToast();
    const setPreference = useSetPreference();

    return useCallback(async (editorId: string) => {
        try {
            await setPreference.mutateAsync({ key: DEFAULT_EDITOR, value: editorId });
        } catch (e) {
            toast({
                title: "Failed to update default editor",
                description: formatError(e),
            });
        }
    }, [setPreference, toast]);
}
